"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("height:1px;display:block;width:100%;background-color:", theme.color.divider, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var styles = {
  base: base
};
exports.styles = styles;
//# sourceMappingURL=divider.styles.js.map